var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 28V17.3333",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5 21.3333L16.5 17.3333L20.5 21.3333",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    id: "Vector 214",
    d: "M9.16667 23.3333C7.83333 23.1111 4.5 22.2667 4.5 18C4.5 14.6667 7.16667 12.6667 9.16667 12.6667C9.16667 10.6667 11.1667 5.33334 16.5 5.33334C22.5 5.33334 23.8333 11.3333 23.8333 12.6667C25.1667 12.6667 28.5 14.2667 28.5 18C28.5 21.7334 25.1667 22.8889 23.8333 23.3333",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload_cloud.297319d163a0e6a364a68d77a8bd7a16.svg";
export { ForwardRef as ReactComponent };